import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { getPhoto, nPhotos } from "../res/imgs/slideshow"
import { breakpointsMax } from "../res/styles/Common"

const Container = styled.div`
    width: 400px;
    height: 400px;
    @media ${breakpointsMax.mobileL} {
        width: 100%;
    }
`

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 1px solid transparent;
    border-radius: 8px;

    ${(props) => props.fadeout} {
        opacity: 0;
        -webkit-transition: 0.5s ease-in-out;
        -moz-transition: 0.5s ease-in-out;
        -ms-transition: 0.5s ease-in-out;
        -o-transition: 0.5s ease-in-out;
        transition: 0.5s ease-in-out;
    }

    ${(props) => props.fadein} {
        opacity: 1;
        -webkit-transition: 0.5s ease-in-out;
        -moz-transition: 0.5s ease-in-out;
        -ms-transition: 0.5s ease-in-out;
        -o-transition: 0.5s ease-in-out;
        transition: 0.5s ease-in-out;
    }
`

function Slideshow() {
    const [currentSlide, setCurrentSlide] = useState(0)
    const [currentFade, setCurrentFade] = useState("fadeout")
    const maxSlides = nPhotos()

    useEffect(() => {
        const f = () => {
            setCurrentFade("fadein")
            setTimeout(() => {
                if (currentSlide === maxSlides - 1) setCurrentSlide(0)
                else setCurrentSlide(currentSlide + 1)
                setCurrentFade("fadeout")
            }, 500)
        }
        const inter = setInterval(f, 3000)
        return () => {
            window.clearInterval(inter)
        }
    })

    return (
        <Container>
            <Image
                fadeout={currentFade === "fadeout" ? true : false}
                fadein={currentFade === "fadein" ? true : false}
                src={getPhoto(currentSlide)}
            />
        </Container>
    )
}

export default Slideshow
